import { render, staticRenderFns } from "./AboutCards.vue?vue&type=template&id=e53acf3e"
import script from "./AboutCards.vue?vue&type=script&lang=js"
export * from "./AboutCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports